import { useTranslations } from 'contexts/Translation'
import PropTypes from 'prop-types'
import { Row, Col, Text } from '@qonsoll/react-design'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { OfferSimpleView } from 'domains/Offer/components'

const OfferList = (props) => {
  const { offers, isListWithCreate, listView, emptyProps, actions } = props

  // [COMPONENT_STATE_HOOKS]
  const [selectedItem, setSelectedItem] = useState(null)

  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()

  // [HANDLERS]
  const onEmptySpaceClick = () => setSelectedItem(null)

  return (
    <Row onClick={onEmptySpaceClick} mx={-3}>
      {offers?.length > 0 ? (
        offers?.map((offer, index) => (
          <Col mb={4} key={offer?._id || index} cw={listView ? 12 : [12, 6, 4]}>
            <OfferSimpleView
              actions={actions}
              index={index}
              isSelected={offer?._id === selectedItem}
              onSelect={setSelectedItem}
              offer={offer}
            />
          </Col>
        ))
      ) : (
        <Col cw={isListWithCreate ? 'auto' : 12}>
          <Text variant="overline" type="secondary">
            {emptyProps?.message || t('No offers have been created yet')}
          </Text>
        </Col>
      )}
    </Row>
  )
}

OfferList.propTypes = {
  offers: PropTypes.array,
  isListWithCreate: PropTypes.bool,
  listView: PropTypes.bool,
  emptyProps: PropTypes.object,
  actions: PropTypes.shape({
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onClick: PropTypes.func
  })
}

export default OfferList
